import { BaseModel, ModelTemplate, RecursivePartial } from '@models/base';
import { VzParamOldStyles } from './param-styles';
import { VzParamOldConstraints } from './param-constraints';
import { VzParamOldTrigger } from './param-trigger';
import { VzParamOldTplvar } from './param-tplvar';
import { IdNameType } from '@models/shared/id-name-type';

export enum VzParamOldType {
    Boolean      = 1,
    String       = 2,
    Integer      = 3,
    Text         = 4,
    ProjectId    = 5,
    GroupId      = 6,
    UIGroup      = 7,  // fake param for groupping other params
    // Enum         = 8,  // deprecated, set enumValues
    OrgId        = 9,
    User4AdminId = 10,
    IntRange     = 11,
    Date         = 12,
    UIAction     = 13, // fake param to provide some interaction, button for example
    Color        = 14,
    // JsonArray    = 15, // deprecated, use JsonObject
    JsonObject   = 16,
    ChatId       = 17,
    RichText     = 18,
    Array        = 19,
    Object       = 20,
    ParamFilter  = 21,
}

export interface IVzParamOld extends ModelTemplate<VzParamOld> {}
export class VzParamOld extends BaseModel {
    static Type = VzParamOldType;
    id!: string;
    type!: VzParamOldType;
    name?: string;
    description?: string;
    defaultValue?: any;
    constraints?: VzParamOldConstraints;
    styles?: VzParamOldStyles;
    enumValues?: number[] | string[];
    enumNames?: string[];
    enumTypes?: VzParamOldType[];
    children?: VzParamOld[];
    triggers?: VzParamOldTrigger[];
    tplVars?: VzParamOldTplvar[];                                        // array of template variables for VzParamType.RichText
    isOutput?: boolean;

    _enumData?: ModelTemplate<IdNameType>[];
    _enumMap?: { [id: number | string]: ModelTemplate<IdNameType> };
    _path?: string = '';

    constructor(json?: RecursivePartial<VzParamOld>) {
        super(json);
        this.parseTaskAction(json || {});
    }

    parse(json: RecursivePartial<VzParamOld>): VzParamOld {
        super.parse(json);
        this.parseTaskAction(json);
        return this;
    }

    private parseTaskAction(json: RecursivePartial<VzParamOld>): void {
        VzParamOld.assignFields<VzParamOld>(this, json, [
            'id',
            'type',
            'name',
            'description',
            'defaultValue',
            'enumValues',
            'enumNames',
            'enumTypes',
            'isOutput',
            '_path'
        ]);
        VzParamOld.assignClassFields<Omit<VzParamOld, 'defaultValue'>>(this, json, {
            constraints: VzParamOldConstraints,
            styles: VzParamOldStyles
        });
        VzParamOld.assignClassArrays<Omit<VzParamOld, 'defaultValue' | 'enumData'>>(this, json, {
            children: VzParamOld,
            triggers: VzParamOldTrigger,
            tplVars: VzParamOldTplvar
        }, { children: { _path: this._path ? this._path + '/' + this.id : this.id } });
        this._enumData = this.enumValues
            ? this.enumValues.map((v, i) => ({ id: v, name: this.enumNames?.[i] || v as string, type: this.enumTypes?.[i] }))
            : undefined;
        if (this._enumData) {
            this._enumMap = {};
            this._enumData.forEach(d => this._enumMap![d.id!] = d);
        }
        else {
            this._enumMap = undefined;
        }
    }

}
